/**
 * PATH: apps/assets/src/pages/TrackingPage.tsx
 * PURPOSE: Asset location tracking
 */
import { EmptyRegister } from './emptyRegister'

export default function TrackingPage() {
  return (
    <EmptyRegister
      title="Tracking"
      detail="No asset locations are connected."
    />
  )
}
